import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { DiplomaSelection, FIRItem, QualificationType} from '../../models/CommonModels';
import {CommonService} from '../../shared/services/common.service';
import * as Constants from '../../models/Constants';
import {ProfessionalControls} from '../../models/CommonModels';
import {ApplicationDetail} from '../../models/ApplicationDetail';
import { AccountService } from '../../services/account.service';
import {ProfessionalFieldConfig, ProfessionalTypeConfig} from '../../models/ProfessionalType';

@Component({
  selector: 'app-professionals',
  templateUrl: './professionals.component.html',
  styleUrls: ['./professionals.component.css']
})
export class ProfessionalsComponent implements OnInit {
  @Input() showErrors: boolean;
  @Input() appForm: FormGroup;
  @Input() appDetail: ApplicationDetail;
  @Input() professionalTypeConfigList: ProfessionalTypeConfig[];
  @Output() storeManagerQualificationChanged = new EventEmitter<boolean>(); // to send data to the parent
  @Output() diplomaSelection = new EventEmitter<DiplomaSelection>();
  @ViewChild('otherValue') otherValue;

  public controls: ProfessionalControls[];
  public professionalForm: FormGroup;
  public form: any;
  currentUserRoleCodes: String[];
  public isClerk = false;
  public qualificationDisabledByEduSelection = false;
  public lookups = { [Constants.EDUCATION_LEVEL_CODE] : new Array(), [Constants.QUAL_CODE] : new Array()};

  public disabled: Object = {
    tlQualification: false,
    pmQualification: false,
    smQualification: false,
    qaQualification: false,
    hseQualification: false
 };
 public constants: any = Constants;

 private professionalNameToFIRMap = { 
   "Technical Leader" : "Technical Manager",
   "Production Manager" : "Production Manager",
   "Quality Assurance" : "Quality Assurance Supervisor Head",
   "Store Manager" : "Store Manager",
   "Hygiene and Sanitation Expert" : "Hygiene and Sanitation Expert",
   "Physico-chemical Expert" : "Physico Chemical Expert",
   "Microbiologist" : "Microbiologist",
   "Quality Control" : "Quality Control",
   "Warehouse Manager" : "Warehouse Manager"
 }

 constructor(public commonService: CommonService, private accountService: AccountService, private fb: FormBuilder) {
  }

  ngOnInit() {
    this.form = this.appForm.controls.professionals;
    // if(this.form.get(this.controls.educationLevel).value) this.disableQualification(this.controls.educationLevel);
    console.log('form ', this.findInvalidControls());
    this.currentUserRoleCodes = this.accountService.getUserRoleCodes();
    if (this.currentUserRoleCodes[0] === Constants.DATA_ENTRY_CLERK) {
        this.isClerk = true;
    }
    this.professionalForm = this.appForm.get('professionals') as FormGroup;
    this.professionalTypeConfigList.forEach(profTypeConfig => {
      this.lookups[Constants.EDUCATION_LEVEL_CODE][profTypeConfig.professionalType.professionalTypeCode] = 
        profTypeConfig.educationLevelConfig.map(c => c.educationLevel).sort(function (a, b) {
        return a.rank - b.rank;
      });

      this.lookups[Constants.QUAL_CODE][profTypeConfig.professionalType.professionalTypeCode]= {};
      profTypeConfig.educationLevelConfig.forEach(eduLevelConfig => {
        this.lookups[Constants.QUAL_CODE][profTypeConfig.professionalType.professionalTypeCode][eduLevelConfig.educationLevelID] =
          eduLevelConfig.qualificationConfig.map(c => c.qualification);
      });
  
      const profFieldConfig = profTypeConfig.professionalFieldConfig
        .find(pfc => pfc.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE);
      this.lookupSelectionChanged(profTypeConfig, profFieldConfig);
    });
  }

  getEducationLevelValue(profTypeConfig : ProfessionalTypeConfig){
    let formatControlName = this.formatControlName(profTypeConfig, profTypeConfig.professionalFieldConfig.find(m => m.professionalField.professionalFieldCode == Constants.EDUCATION_LEVEL_CODE));
    return this.professionalForm.controls[formatControlName].value;
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.appForm.controls.professionals['controls'];
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
  }

  inputIsDisabled(inputValue, professionalTitle, controlName) {
    
   let disabled = false;

    if (this.appDetail) {

      if (this.appDetail.isLegacyData && inputValue) {

        if (this.appDetail.applicationStatusCode === Constants.FIR_SUBMITTED) {
          let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
          let groupIndex = editFields.findIndex(item => item.name === 'Facility Professionals');

          if (groupIndex === -1) {
            disabled = inputValue.valid;
          } else {
            disabled = inputValue.valid && editFields[groupIndex].subItems.findIndex(item => item.name === this.professionalNameToFIRMap[professionalTitle]) === -1;
          }
        } else {
          disabled = !this.isClerk &&  !(inputValue.value === null || inputValue.value === '' || inputValue.value === undefined) &&
            !inputValue.dirty;
        }
      } else if (this.appDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.appDetail.applicationStatusCode)) {
        let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
        let groupIndex = editFields.findIndex(item => item.name === 'Facility Professionals');

        if (groupIndex === -1) {
          disabled = inputValue ? inputValue.valid && !inputValue.dirty : true;
        } else {
          disabled = Boolean(inputValue ? inputValue.valid && !inputValue.dirty && editFields[groupIndex].subItems.findIndex(item =>
            item.name === this.professionalNameToFIRMap[professionalTitle]) === -1 :
            editFields[groupIndex].subItems.findIndex(item => item.name === this.professionalNameToFIRMap[professionalTitle]) === -1);}

      }
    }
    if (controlName && controlName.indexOf('Qualification') > -1) {
        return disabled || this.qualificationDisabledByEduSelection;
    }
    return disabled;
  }

  isFIR(controlName) {
    if (this.appDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.appDetail.applicationStatusCode)) {
      let editFields: FIRItem[] = JSON.parse(this.appDetail.editedFields);
      let groupIndex = editFields.findIndex(item => item.name === 'Facility Professionals');

      if (groupIndex === -1) {
        return false;
      }

      return !(editFields[groupIndex].subItems.findIndex(item => item.name === controlName) === -1);
    }
    return false;
  }


  isInputHighlighted(inputValue, professionalTitle, controlName) {
    return { 'input-highlight': !this.inputIsDisabled(inputValue, professionalTitle, controlName) &&
        this.appDetail && [Constants.FIR_SUBMITTED, Constants.FIR_SUBMITTED_AFTER_INSPECTION].includes(this.appDetail.applicationStatusCode)};
  }

  formatControlName(profTypeConfig, field) {
   return profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + field.professionalField.name.replace(/ /g, '')
     + (field.professionalField.dataType === 'lookup' ? 'ID' : '');
  }

  getLookups(profTypeConfig: ProfessionalTypeConfig, field: ProfessionalFieldConfig) {
   const eduLevelConfig = profTypeConfig.educationLevelConfig;

   if (field.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
     return eduLevelConfig.map( elc => {
       return {...elc.educationLevel};
   }).sort(function (a, b) {
       return a.rank - b.rank;
     });
   } else if (field.professionalField.professionalFieldCode === Constants.QUAL_CODE) {
     const eduControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'EducationLevelID';
     const qualControlName = this.formatControlName(profTypeConfig, field);
     const selectedEduLevelID = this.professionalForm.get(eduControlName).value;
     let selectedEduLevelConfig, qualConfigs;
     if (selectedEduLevelID) {
       selectedEduLevelConfig = eduLevelConfig.find(elc => elc.educationLevelID === selectedEduLevelID);
       if (selectedEduLevelConfig) {
         qualConfigs = selectedEduLevelConfig.qualificationConfig;
       }
     }
     if (!qualConfigs) {
       qualConfigs = this.getUniqueList([].concat.apply([], eduLevelConfig.map( elc => {
         return elc.qualificationConfig;
       })));
     }
     const lookupValue = qualConfigs.map (qc => {return qc.qualification; });
     // if selected qual does not exist on new qual list, set value on form to null
     const selectedQualID = this.professionalForm.get(qualControlName).value;
     if (selectedQualID) {
       const selectedQualExistsInLookupList = Boolean(lookupValue.find(lv => lv.id === selectedQualID));
       if (!selectedQualExistsInLookupList) {
         this.professionalForm.get(qualControlName).setValue(null);
       }
     }
     return lookupValue;
  }
  }

  getUniqueList(arr) {
    return arr.filter((thing, index, self) =>
      index === self.findIndex((t) => (
        t.place === thing.place && t.name === thing.name
      ))
    );
  }

  getMinExperience(profTypeConfig) {
    let minExperience = 0;
    const eduLevelConfig = profTypeConfig.educationLevelConfig;
    const eduControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'EducationLevelID';
    const qualControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'QualificationID';
    const experienceControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'Experience';
    const selectedEduLevelID = this.professionalForm.get(eduControlName).value;
    const selectedQualID = this.professionalForm.get(qualControlName).value;
    let selectedEduLevelConfig, qualConfig;
    if (selectedEduLevelID) {
      selectedEduLevelConfig = eduLevelConfig.find(elc => elc.educationLevelID === selectedEduLevelID);
      if (selectedEduLevelConfig) {
        qualConfig = selectedEduLevelConfig.qualificationConfig.find(qc => qc.qualification.id === selectedQualID);
        minExperience = qualConfig ? qualConfig.minExperience : 0;
      }
    }
    if(profTypeConfig.professionalFieldConfig.find(pfc => pfc.professionalField.professionalFieldCode == 'EXP').required){

      this.professionalForm.get(experienceControlName).setValidators([Validators.min(minExperience), Validators.required]);
    }else
    {
      this.professionalForm.get(experienceControlName).setValidators(Validators.min(minExperience));
    }
    
    this.professionalForm.get(experienceControlName).updateValueAndValidity();
    return minExperience;
  }

  lookupSelectionChanged(profTypeConfig, field) {
    const qualControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'QualificationID';
    const eduControlName = profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + 'EducationLevelID';
    const qualConfig = this.professionalTypeConfigList.find(ptc => ptc.id === profTypeConfig.id)
      .professionalFieldConfig.find(f => f.professionalField.professionalFieldCode === Constants.QUAL_CODE);
    if (field.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
      // check isQualDisabled field and change qual requirement
      const selectedEduLevel = this.getLookups(profTypeConfig, field).find(edl => edl.id === this.professionalForm
                                      .get(eduControlName).value);
      if (selectedEduLevel && selectedEduLevel.qualificationDisabled) {
        this.professionalForm.get(qualControlName).clearValidators();
        this.professionalForm.get(qualControlName).updateValueAndValidity();
        qualConfig.required = false;
      } else if (qualConfig.required) {
        this.professionalForm.get(qualControlName).setValidators(Validators.required);
        this.professionalForm.get(qualControlName).updateValueAndValidity();
        qualConfig.required = true;
      }
      this.qualificationDisabledByEduSelection = selectedEduLevel ? selectedEduLevel.qualificationDisabled : false;

      // diploma selection has an effect on the requiredness of some documents
      const diplomaObject = this.professionalTypeConfigList.find(ptc => ptc.id === profTypeConfig.id)
        .educationLevelConfig.find(ec => ec.educationLevel.name == Constants.DIPLOMA);

      let diplomaSelection = new DiplomaSelection(eduControlName, diplomaObject !== undefined &&
        this.form.get(eduControlName).value === diplomaObject.educationLevelID);

      this.diplomaSelection.emit(diplomaSelection);

    } else {
      // check and set min experience? maybe not needed
    }

    if(field.professionalField.professionalFieldCode === Constants.QUAL_CODE)
    {
      if(profTypeConfig.professionalType.professionalTypeCode == Constants.STORE_MANAGER_CODE)
      {
        // store manager pharmacist selection has an effect on the requiredness of some documents
        const smConfig = this.professionalTypeConfigList.find(pc => pc.professionalType.professionalTypeCode === Constants.STORE_MANAGER_CODE);
        const eduConfig = smConfig.educationLevelConfig.find(ec => ec.educationLevelID == this.appForm.value.professionals.smEducationLevelID);
        const quaConfig = eduConfig.qualificationConfig.find(qc => qc.qualificationID === this.appForm.value.professionals.smQualificationID);
        if (quaConfig !== undefined && quaConfig.qualification.name === Constants.PHARMACIST){
          this.storeManagerQualificationChanged.emit(true);
        }else {
          this.storeManagerQualificationChanged.emit(false);
        }
      }
    }
  }
}
